import {Dispatch, SetStateAction} from 'react'
import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
  RequestResult,
} from '../../lib'

import {doREQUEST_ERROR, doREQUEST_COMPLETE, doMETHOD_ADD_TASK, doTEMP_TASK_DATA_REPLACE_TEMP_TASK} from '../state'
import {getToken} from './token_fetcher'

export const REQUEST_TASK_STOPWATCH_GARMIN_STREAM_CREATE = 'REQUEST_TASK_STOPWATCH_GARMIN_STREAM_CREATE'
export const doREQUEST_TASK_STOPWATCH_GARMIN_STREAM_CREATE = createDoRequestAction(
  REQUEST_TASK_STOPWATCH_GARMIN_STREAM_CREATE,
)

export const requestTaskStopwatchGarminStreamCreateActionCreators = {
  doREQUEST_TASK_STOPWATCH_GARMIN_STREAM_CREATE,
}

interface Payload {
  payload: {
    requestId: string
    methodId: string
    color: string
    scheduleRepeat: boolean
    scheduleDescription: string
    name: string
    description: string
    accEnable: boolean
    accHz: number
    tempTaskId: string
    reminderList?: Record<string, string>[]
    timeLimitSeconds: number
  }
  setRequestResult?: Dispatch<SetStateAction<RequestResult | null>>
}

export function* requestTaskStopwatchGarminStreamCreate({payload, setRequestResult}: Payload): SagaIterator {
  debug('saga*requestTaskStopwatchGarminStreamCreate')

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().required(),
        methodId: v.string().uuid().required(),
        color: v.string().required(),
        scheduleRepeat: v.boolean(),
        scheduleDescription: v.string().optional(),
        name: v.string().required(),
        description: v.string().optional(),
        accEnable: v.boolean().required(),
        accHz: v.number().valid(25, 50, 100).optional().allow(null),
        tempTaskId: v.string().uuid().optional(),
        reminderList: v.array().optional(),
        timeLimitSeconds: v.number().required(),
      }),
    })
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_TASK_STOPWATCH_GARMIN_STREAM_CREATE,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    )
  }

  const {
    methodId,
    color,
    scheduleRepeat,
    scheduleDescription,
    name,
    description,
    accEnable,
    accHz,
    tempTaskId,
    reminderList,
    timeLimitSeconds,
  } = payload

  const accessToken = yield call(getToken)

  const result = yield request({
    method: 'post',
    url: `${API_URL}/v1/web/task-stopwatch-garmin-stream-create`,
    accessToken,
    data: {
      methodId,
      color,
      scheduleRepeat,
      scheduleDescription,
      name,
      description,
      accEnable,
      accHz,
      reminderList,
      timeLimitSeconds,
    },
  })

  if (!result.success || result.error) {
    const error = result.error || new Error('request did not succeed')
    debug(error)
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_TASK_STOPWATCH_GARMIN_STREAM_CREATE,
          fromPayload: payload,
          requestId: payload.requestId,
          url: '/v1/web/task-stopwatch-garmin-stream-create',
          ...result,
          error,
        },
        setRequestResult,
      ),
    )
  }

  if (tempTaskId) {
    yield put(
      doTEMP_TASK_DATA_REPLACE_TEMP_TASK({
        tempTaskId,
        newId: result.payload.id,
      }),
    )
  } else {
    yield put(doMETHOD_ADD_TASK({...result.payload}))
  }

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_TASK_STOPWATCH_GARMIN_STREAM_CREATE,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  )
}

export function* taskStopwatchGarminStreamCreateSaga() {
  yield takeEvery(REQUEST_TASK_STOPWATCH_GARMIN_STREAM_CREATE as any, requestTaskStopwatchGarminStreamCreate)
}
